enum ModalType {
  NewPixel = 'NEW_PIXEL',
  ViewPixel = 'VIEW_PIXEL',
}

export default ModalType;
